<div class="hotels-search-fileds mt-4">
  <div class="one-way-flight-search round-trip-search">
    <form [formGroup]="hotelSearchForm" class="w-100">
      <div class="from-to-city hotel-location-input">
        <div class="from-city-name form-input">
          <input formControlName="fromDestination"
       placeholder="{{ 'Choose a travel destination' | translate }}" class="form-control"
       (input)="onInputChanged($event)">
       <div class="input-error up-side-error" *ngIf="fromDestinationError">
        <div><i class="fa-solid fa-circle-exclamation"></i> {{'Destination is required' | translate}}</div>
      </div>
       <div *ngIf="showDropdown && apiResponse && apiResponse.success" class="hotel-city-finder-drop">
        <ul>
          <h5><i class="fa-solid fa-location-dot"></i> Locations</h5>
          <div *ngFor="let item of apiResponse.data">
            <li *ngIf="item.type === 'city'" (click)="selectDestination(item.DestinationName, item.CityCode)">
              {{ item.DestinationName }}, {{item.CityCode}}
            </li>
          </div>
        </ul>
        <ul>
          <h5><i class="fa-solid fa-hotel"></i> Hotels</h5>
          <div *ngFor="let item of apiResponse.data">
            <li *ngIf="item.type === 'hotel'" (click)="selectDestination(item.DestinationName, item.CityCode)">
              {{ item.DestinationName }}, {{item.CityCode}}
            </li>
          </div>
        </ul>
      </div>

          <label for=""><i class="fa-solid fa-location-dot"></i></label>
        </div>
      </div>
      <div class="departure-date">
        <div class="date-range-container position-relative mb-1">
          <input class="form-control"
            formControlName="checkInDate"
            placeholder="Check In Date"
            [(ngModel)]="checkInDate"
            bsDatepicker
            [bsConfig]="bsConfig"
            [bsValue]="checkInDate"
            [minDate]="minDate"
            (bsValueChange)="updateCheckOutDate($event)">
          <label for="new-start-date"><img src="/assets/image/search/calender.png" alt="" /></label>
          <div class="input-error up-side-error" *ngIf="checkInDateError">
            <div><i class="fa-solid fa-circle-exclamation"></i> {{'Check In date is required' | translate}}</div>
          </div>
        </div>

        <div class="date-range-container position-relative mb-1">
          <input class="form-control"
          formControlName="checkOutDate"
            placeholder="Check Out Date"
            [(ngModel)]="checkOutDate"
            bsDatepicker
            [bsConfig]="bsConfig"
            [bsValue]="checkOutDate"
            [minDate]="checkInDate">
          <label for="new-end-date"><img src="/assets/image/search/calender.png" alt="" /></label>
          <div class="input-error up-side-error" *ngIf="checkOutDateError">
            <div><i class="fa-solid fa-circle-exclamation"></i> {{'Check Out date is required' | translate}}</div>
          </div>
        </div>

      </div>
      <div class="travellers-info hotel-class-select">
        <div class="class-selection mt-0">
          <div class="selected-class" (click)="dropdownOpen()">
            {{ selectedHotelClass | translate }}
            <img src="assets/image/red-down.png" width="10" class="mx-1" alt="" />
          </div>
          <div class="class-content" *ngIf="contentdropdown">
            <ul>
              <li *ngFor="let arr of hotelClass; index as i" [class.active]="i === colorvariable"
                (click)="changeCode(arr); dropdownOpen()">
                <b>{{ arr.displayName | translate }}</b>
              </li>
            </ul>
          </div>

          <div class="class-selection">
            <div class="selected-class" (click)="dropdownOpenRoom()">
              {{ selectedRoomClass | translate }}
              <img src="assets/image/red-down.png" width="10" class="mx-1" alt="" />
            </div>
            <div class="class-content" *ngIf="contentdropdownRooms">
              <ul>
                <li *ngFor="let arr of hotelRoomClass; index as i" [class.active]="i === colorvariable"
                  (click)="changeCodeRooms(arr); dropdownOpenRoom()">
                  <b>{{ arr.displayName | translate }}</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="travellers-info hotel-class-select form-input">
        <input type="text" autocomplete="off" readonly [value]="getTotalRoomsAndTravelersText()" formControlName=""
          class="expander w-100 main-travlers-list-visible" (click)="toggleTravellersInfoDrop()" />
        <label for=""><i class="fa-solid fa-user"></i></label>
        <div class="travellers-info-drop" id="TableData" [hidden]="!isTravellersInfoVisible">
          <div id="rooms-container">
            <div *ngFor="let room of rooms; let i = index" class="traveller-rooms">
              <h5>
                {{ room.title }}
                <span class="remove-rooms" (click)="removeRoom(i)" *ngIf="rooms.length > 1 && i > 0"><i
                    class="fa-solid fa-trash"></i>Delete</span>
              </h5>
              <a data-bs-toggle="collapse" role="button" [attr.aria-expanded]="room.isCollapsed.toString()"
                [attr.aria-controls]="'collapseExample' + i" (click)="toggleRoomCollapse(i)">
                {{ getTotalTravelers(room) }} Travelers
                <i class="fa-solid fa-chevron-down"></i>
              </a>
              <div [ngClass]="{ collapse: true, show: !room.isCollapsed }" [id]="'collapseExample' + i">
                <div class="card card-body">
                  <span class="travel-titl-spans">
                    Adult (13+)
                    <div class="counters-hotel-travellrs">
                      <div class="input-group w-auto align-items-center">
                        <button type="button" class="button-minus border icon-shape icon-sm mx-1"
                          (click)="decrementAdults(room)">
                          -
                        </button>
                        <input type="number" step="1" min="1" max="10" placeholder="Adult (12+)" [value]="room.adults" formControlName="adults"
                          name="adultQuantity" class="quantity-field border-0 text-center w-25" />
                        <button type="button" class="button-plus border icon-shape icon-sm"
                          (click)="incrementAdults(room)">
                          +
                        </button>
                      </div>
                    </div>
                  </span>
                  <span class="travel-titl-spans">
                    Child (2-12)
                    <div class="counters-hotel-travellrs">
                      <div class="input-group w-auto align-items-center mb-1">
                        <button type="button" class="custom-button-minus border icon-shape icon-sm mx-1"
                          (click)="decrementChildren(room)">
                          -
                        </button>
                        <input type="number" step="1" min="0" max="6" placeholder="Child (2-12)" [value]="room.children" formControlName="children"
                          name="childQuantity" class="custom-quantity-field border-0 text-center w-25" />
                        <button type="button" class="custom-button-plus border icon-shape icon-sm"
                          (click)="incrementChildren(room)">
                          +
                        </button>
                      </div>
                    </div>
                  </span>
                  <div class="child-age-opts">
                    <div *ngFor="let childIndex of getRange(room.children)" class="selected-childs-ages">
                      <span class="travel-titl-spans">Child {{ childIndex + 1 }} age</span>
                      <select class="form-select" [id]="'selectbox' + (i + 1) + '_' + (childIndex + 1)">
                        <option data-age="0" value="1">Under 1</option>
                        <option data-age="1" value="2">1</option>
                        <option data-age="2" value="3">2</option>
                        <option data-age="3" value="4">3</option>
                        <option data-age="4" value="5">4</option>
                        <option data-age="5" value="6">5</option>
                        <option data-age="6" value="7">6</option>
                        <option data-age="7" value="8">7</option>
                        <option data-age="8" value="9">8</option>
                        <option data-age="9" value="10">9</option>
                        <option data-age="10" value="11">10</option>
                        <option data-age="12" value="12">12</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="add-more-rooms">
            <button type="button" class="add-room-button" (click)="addRoom()" [disabled]="isAddRoomDisabled()">
              Add Room
            </button>
            <button type="button" class="apply-button" (click)="toggleTravellersInfoDrop()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <a (click)="onSearchButtonClick()"><img src="/assets/image/search/search-ico.png" alt="" />Search</a>
      </div>
    </form>
  </div>
</div>
